import React from "react";
import { Switch, Route } from "react-router-dom";
import Containers from "./Containers";

export default function Containersview() {
  return (
    <div>
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/containers"
            render={(props) => <Containers {...props} />}
          />
        </Switch>
      </React.Fragment>
    </div>
  );
}
